<template>
  <div>
    <AppDialog :is-open="isDialogOpened"
               :ok-text="$t('subscriptions.RestoreRoomDialog.restore')"
               :ok-loading="restoreRoomPending"
               :ok-disabled="restoreRoomPending"
               :cancel-disabled="restoreRoomPending"
               size="l"
               @ok="prepareRestoreRoom"
               @cancel="closeDialog"
    >
      <template #title>
        {{ $t('subscriptions.RestoreRoomDialog.title') }}
      </template>

      <template #body>
        <p class="mb-4">{{ $t('subscriptions.RestoreRoomDialog.text1') }}</p>

        <p>{{ $t('subscriptions.RestoreRoomDialog.text2') }}</p>

        <p class="mt-8">{{ $t('subscriptions.RestoreRoomDialog.notify') }}</p>
        <v-checkbox v-model="notifyPms"
                    :label="$t('subscriptions.RestoreRoomDialog.notifyPms')"
                    hide-details
        />
        <v-checkbox v-model="notifyGuests"
                    :label="$t('subscriptions.RestoreRoomDialog.notifyGuests')"
                    hide-details
        />
      </template>
    </AppDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import AppDialog from '@/common/dialogs/AppDialog.vue'
import { toast } from '@/common/utils/toast'
import { dialogMixin } from '@/mixins/dialogMixin'
import { RESTORE_ROOM } from '@/store/modules/subscription/action_types'

export default {
  name: 'RestoreRoomDialog',
  components: { AppDialog },
  mixins: [dialogMixin],
  props: {
    roomId: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      notifyPms: true,
      notifyGuests: true,
    }
  },
  computed: {
    ...mapState('subscription', ['restoreRoomPending']),
  },
  methods: {
    ...mapActions('subscription', [RESTORE_ROOM]),
    async prepareRestoreRoom () {
      try {
        await this.RESTORE_ROOM({
          roomId: this.roomId,
          data: {
            notifyPms: this.notifyPms,
            notifyGuests: this.notifyGuests,
          },
        })
        toast.success(this.$t('subscriptions.RestoreRoomDialog.restoreRoomSuccess'))
        this.$emit('confirm')
      } catch (error) {
        console.error(error)
        toast.error(this.$t('subscriptions.RestoreRoomDialog.restoreRoomError'))
      }
    },
  },
}
</script>
